"use client";

import { motion, useReducedMotion } from "@/lib/motion";
import { scrollRevealViewport } from "@/lib/motion-viewport";
import CodeBlock from "@/components/ui/code-block";

const EXAMPLE_CODE = `# HTTP(S): send your outbound IP check through the proxy
curl --proxy "http://your_username:your_password@gate.proxidize.com:7777" \\
     https://api.ipify.org?format=json

# SOCKS5
curl --socks5 "your_username:your_password@gate.proxidize.com:7778" \\
     https://api.ipify.org?format=json`;

export default function ConfigExample() {
  const reduced = useReducedMotion() ?? false;

  return (
    <section
      aria-labelledby="config-example-heading"
      className="border-border py-section-sm relative border-b"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={reduced ? false : { opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={scrollRevealViewport}
          transition={{ duration: 0.5 }}
        >
          <p className="text-muted-foreground mb-3 text-xs font-semibold">Configuration</p>
          <h2
            id="config-example-heading"
            className="text-foreground mb-3 scroll-mt-40 text-3xl font-bold tracking-tight sm:text-4xl"
          >
            Basic configuration example
          </h2>
          <p className="text-muted-foreground mb-6 text-base leading-relaxed">
            Most clients authenticate with a username and password over HTTP(S) or SOCKS5. This is
            the same host and port format used throughout Proxidize&apos;s own docs.
          </p>
          <CodeBlock code={EXAMPLE_CODE} lang="bash" />
        </motion.div>
      </div>
    </section>
  );
}
